import React from 'react';
import FullHeader from './FullHeader';
import RegistrationCard from './RegistrationCard';

const RegisterView = props => {
  return (
    <div>
      <FullHeader {...props} />
      <RegistrationCard {...props} />
    </div>
  )
};

export default RegisterView;


// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegisterView.js